export let updateAvailable = false

export const setUpdateAvailable = () => (updateAvailable = true)
